import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

@Component({
  selector: 'app-icon-renderer',
  templateUrl: './icon-renderer.component.html',
  styleUrls: ['./icon-renderer.component.css'],
})
export class IconRendererComponent implements ICellRendererAngularComp {
  iconPath!: string;

  iconText!: string;

  // gets called once before the renderer is used
  agInit(params: IconRendererParams): void {
    if (params.iconPathKey in params.data) {
      this.iconPath = params.data[params.iconPathKey];
    } else if (params.iconNameKey in params.data && params.iconGetter) {
      this.iconPath = params.iconGetter(params.data[params.iconNameKey]);
    }
    if (params.iconTextHandler) {
      this.iconText = params.iconTextHandler(params.data);
    } else if (params.iconTextKey in params.data) {
      if (params.iconTextGetter)
        this.iconText = params.iconTextGetter(params.data[params.iconTextKey]);
      else this.iconText = params.data[params.iconTextKey];
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}

export type IconRendererParams = ICellRendererParams & {
  iconGetter: (name: string) => string;
  iconNameKey: string;
  iconTextKey: string;
  iconTextGetter: (text: string) => string;
  iconPathKey: string;
  iconTextHandler: (data: ValueGetterParams['data']) => string;
};
